






















import { Component, Vue } from 'vue-property-decorator';
import { BusConstants, ModalConstants } from '@/core/constants';

import { RealmsModule } from '@/store/modules/realms/realms.store';
import { Realmlist, RealmLogType, RealmLogViewObject } from '@/types/apiServerContract';
import bus from '@/core/bus';
import { RealmApi } from '@/services/api/api.realms';

@Component
export default class SelectRealm extends Vue {
	id: string = ModalConstants.RealmLogHistoryWindow;

    logType: RealmLogType | null = null;
    logs: RealmLogViewObject[] = [];

    SelectRealm(realm: Realmlist) {
	    RealmsModule.SetActiveRealm(realm.id);
	    this.$bvModal.hide(this.id);
    }

    async GetLogs() {
        if (!this.logType) return;

	    try {
	        this.logs = await RealmApi.getRealmLogs(this.logType);
	    } catch (e) {
            console.log(e);
	        this.$bvToast.toast(e as string);
	    }
    }

    public get title() {
        if (!this.logType) return 'UNKNOWN';
        return `${RealmLogType[this.logType]} Logs`;
    }

    created() {
	    bus.on(BusConstants.RealmLogHistoryType, (realmLogType: RealmLogType) => (this.logType = realmLogType));
    }

    destroyed() {
	    bus.off(BusConstants.RealmLogHistoryType, (realmLogType: RealmLogType) => (this.logType = realmLogType));
    }
}
